<template>
  <div class="auth">
    <div class="auth__error" v-if="error">
      <h3>🚨</h3>
      <p>{{error}}</p>
      <div class="auth__actions">
        <div>
          <router-link :to="{name: 'Login', query: { email }}" v-if="!getUser">
            <span class="g-button">Resend login link</span>
          </router-link>
          <router-link :to="{name: 'Home'}">
            <span class="g-button">Go Home</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="auth__loader" v-else>
      <loader />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '@/components/Loader.vue';

export default {
  name: 'Auth',
  components: {
    Loader,
  },
  methods: {
    ...mapActions(['signIn']),
  },
  data() {
    return {
      email: null,
      error: null,
    };
  },
  computed: {
    ...mapGetters([
      'getUser',
      'getLastRead',
    ]),
  },
  created() {
    const { email } = this.$route.query;
    if (email) {
      this.email = email;
      this.signIn(email).then(() => {
        const home = { name: 'Home' };
        const getURL = stripNumber => ({ name: 'Comic', params: { stripNumber } });
        const destination = this.getLastRead ? getURL(this.getLastRead) : home;
        this.$router.push(destination);
      }).catch((error) => {
        this.error = error.message;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.auth {
  max-width: 500px;
  margin: 0 auto;
  &__error {
    margin: 0 auto;
    text-align: center;
  }
  &__actions {
    span {
      margin: 5px;
    }
  }
  &__loader {
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
